<template>
    <DexStack
        gap="200"
        align-x="center"
        align-y="center"
        class="empty-state"
    >
        <DexBox padding-bottom="100">
            <DexInline>
                <DexIllustration
                    v-if="image"
                    data-qa="image"
                    :name="image"
                />
            </DexInline>
        </DexBox>

        <DexText
            v-if="title || slots.title"
            as="h3"
            variant="display-3-alt"
            color="default"
            data-qa="title"
        >
            <slot name="title">
                {{ title }}
            </slot>
        </DexText>

        <DexText
            v-if="description || slots.description"
            variant="body-2"
            data-qa="description"
            color="subtle"
            class="empty-state-description"
        >
            <slot name="description">
                {{ description }}
            </slot>
        </DexText>

        <DexBox v-if="slots.default" padding-top="100">
            <slot />
        </DexBox>
    </DexStack>
</template>

<script setup>
import { useSlots } from 'vue';
import {
    DexBox,
    DexInline,
    DexIllustration,
    DexStack,
    DexText,
} from '@thryvlabs/dex-vue';

defineProps({
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    image: { type: String, default: '' },
});

const slots = useSlots();
</script>

<style scoped>
.empty-state-description {
    max-width: 31.25rem;
}
</style>
